import { loginNewWrapper } from '@cap/rzmt-core';
import { ENU_COURSE_TYPE } from '@/utils/course';

export function formatLeranProgress(process = 0) {
  return Math.min(process / 100, 100);
}

export function formatTimestamp(timestamp) {
  const totalSeconds = timestamp / 1000;

  // 计算天数
  const days = Math.floor(totalSeconds / (24 * 3600));

  // 计算剩余的小时数
  const hours = Math.floor((totalSeconds % (24 * 3600)) / 3600);

  // 返回格式化的字符串
  return `${days}天${hours}小时`;
}

// 判断是否需要报名
export async function validNeedRegistration({ restrictionSwitch, hadRegistration }) {
  // 判断课程是否关联报名表单
  if (restrictionSwitch) {
    // 如果用户没有登录，跳转登录页面
    const user = await loginNewWrapper.getUserInfo();
    if (user) {
      // 如果用户没有报名，跳转报名页
      if (!hadRegistration) {
        return true;
      }
    } else {
      return true;
    }
  }
  return false;
}

export function getQrCodeValue({ shortUrl, type, id, liveCourseLessonId }) {
  const courseType = ENU_COURSE_TYPE[type];

  // 如果 type 是 5，附加 chapterId 参数
  const chapterIdParam = type === 5 && liveCourseLessonId ? `?chapterId=${liveCourseLessonId}` : '';

  return `${window.location.host}/i/college/${shortUrl}/${courseType}/${id}${chapterIdParam}`;
}

export const getStarTotalData = (starMap, totalCount, totalStar) => {
  Object.keys(starMap).forEach((key: any) => {
    if (key > 0 && key <= 5) {
      totalCount += parseInt(starMap[key], 10);
      totalStar += key * parseInt(starMap[key], 10);
    }
  });
  return { totalCount, totalStar };
};
